/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    $('document').ready(setup);
    var siteUrl = window.location.protocol + '//' + window.location.hostname;
    var isMasonryEnabled = false;
    var initScrllReveal = false;
    let isMobile = $(window).width() < 1000 ? true : false;

    function setup() {
        //initJqueryPassiveListener();
        initTarteAuCitron();
        initPonyfill();
        initTinyMCEedit();
        initToTop();
        initMapEvent();
        smoothanchors();
        $('.scrollanim').click(scrollToNextContent);
        if( $(window).width() >= 1000) initScrollReveal();
        $(window).resize(function() {
            if($(window).width() >= 1000 && !initScrllReveal) initScrollReveal();
        });
    }

    function initPonyfill() {
        //init ponyfill ie11
        cssVars({
            // Options...
        });
    }

    function initTinyMCEedit() {
        $('.btn-simple-tinymce').append('<svg class="icon"><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg>');
    }

    function initJqueryPassiveListener() {
        jQuery.event.special.touchstart = {
            setup: function( _, ns, handle ) {
                this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
            }
        };
        jQuery.event.special.touchmove = {
            setup: function( _, ns, handle ) {
                this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
            }
        };
        jQuery.event.special.wheel = {
            setup: function( _, ns, handle ){
                this.addEventListener("wheel", handle, { passive: true });
            }
        };
        jQuery.event.special.mousewheel = {
            setup: function( _, ns, handle ){
                this.addEventListener("mousewheel", handle, { passive: true });
            }
        };
    }

    function initTarteAuCitron() {
        if (typeof tarteaucitron !== 'undefined') {
            tarteaucitron.init({
                "hashtag": "#tarteaucitron", /* Ouverture automatique du panel avec le hashtag */
                "cookieName": "rma", /* Cookie name */
                "DenyAllCta": true, /* Show the deny all button */
                "AcceptAllCta": true, /* Show the accept all button when highPrivacy on */
                "highPrivacy": true, /* désactiver le consentement implicite (en naviguant) ? */
                "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */
                "orientation": "middle", /* le bandeau doit être en haut (top) ou en bas (bottom) ? */
                "showAlertSmall": true, /* afficher le petit bandeau en bas à droite ? */
                "cookieslist": true, /* Show the cookie list */
                "closePopup": false, /* Show a close X on the banner */
                "showIcon": false, /* Show cookie icon to manage cookies */
                "adblocker": false, /* Show a Warning if an adblocker is detected */
                "removeCredit": true, /* supprimer le lien vers la source ? */
                "useExternalCss": true, /* If false, the tarteaucitron.css file will be loaded */
                "moreInfoLink": true, /* Show more info link */
                "readmoreLink": "", /* Change the default readmore link */
                "gaTimeout": 800
            });
            //tarteaucitron.user.gajsUa = 'UA-7551220-5';
            tarteaucitron.user.googletagmanagerId = 'GTM-NNC6H5W';
            tarteaucitron.user.facebookpixelId = '334351769919641'; tarteaucitron.user.facebookpixelMore = function () {  };
            //tarteaucitron.user.gajsMore = function () { ga('set', 'anonymizeIp', true); };
            //(tarteaucitron.job = tarteaucitron.job || []).push('gajs');
            (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
            (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
            (tarteaucitron.job = tarteaucitron.job || []).push('linkedin');
            (tarteaucitron.job = tarteaucitron.job || []).push('facebookpixel');
        }
    }

    function initScrollReveal() {
        initScrllReveal = true;

        //ScrollReveal du Bloc Push
        ScrollReveal().reveal('.blockpush-wrapper', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'bottom' });

        //ScrollReveal du Bloc Push visuel
        ScrollReveal().reveal('.blockpushvisuel-img', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.blockpushvisuel-content', { delay: 700, duration: 800, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });
        // ScrollReveal().reveal('.blockpushvisuel-img .picto', { delay: 750, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top' });

        //ScrollReveal du Bloc Témoignage simple
        ScrollReveal().reveal('.blocktestimonysimple-text', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.blocktestimonysimple-img', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });
        ScrollReveal().reveal('.blocktestimonysimple-picto .picto', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'bottom' });

        //ScrollReveal du titre spécial
        ScrollReveal().reveal('.title-special', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top' });

        //ScrollReveal des formulaires
        ScrollReveal().reveal('.webform-button', { delay: 50, duration: 800, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });
        ScrollReveal().reveal('.webform-header', { delay: 300, duration: 800, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '50px', origin: 'top' });
        ScrollReveal().reveal('.webform-wrapper', { delay: 400, duration: 800, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '150px', origin: 'bottom' });

        //ScrollReveal Bloc Témoignages croisés
        ScrollReveal().reveal('.blocktestimonycross-text', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.blocktestimonycross-img', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });
        ScrollReveal().reveal('.blocktestimonycross-img.right', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });

        //ScrollReveal Bloc Nombres
        ScrollReveal().reveal('.blocksnumbers-utitle', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.blocksnumbers-wrapper .slick-active', { delay: 200, duration: 600, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', opacity: 0, distance: '50px', scale: 0.8, origin: 'top', interval: 150});
        ScrollReveal().reveal('.blocksnumbers-wrapper .slicknav', { delay: 500, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });

        //ScrollReveal Bloc Partenaires
        ScrollReveal().reveal('.blockpartners-categories', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top' });
        //ScrollReveal().reveal('.blockpartners-logos.active img', { delay: 200, duration: 600, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', opacity: 0, distance: '135px', scale: 0.75, origin: 'bottom', interval: 250});

        //ScrollReveal Bloc Alternance texte et images
        ScrollReveal().reveal('.blockalternance-item', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '250px', origin: 'right' });
        ScrollReveal().reveal('.blockalternance-item.right', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '250px', origin: 'left' });
        ScrollReveal().reveal('.blockalternance-content', { delay: 500, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top' });

        //ScrollReveal Bloc Texte et médias
        ScrollReveal().reveal('.blocktextimg-text', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });
        ScrollReveal().reveal('.blocktextimg-media', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });

        //ScrollReveal Bloc Pêle mêle de couleurs
        ScrollReveal().reveal('.blockcolors-content', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.blockcolors-item.item-0', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top' });
        ScrollReveal().reveal('.blockcolors-item.item-1', { delay: 400, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });
        ScrollReveal().reveal('.blockcolors-item.item-2', { delay: 600, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'bottom' });
        ScrollReveal().reveal('.blockcolors-item.item-3', { delay: 800, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.blockcolors-optional-img', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.blockcolors-optional-content', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'bottom' });

        //ScrollReveal Bloc Texte 3 colonnes
        ScrollReveal().reveal('.blocktext3col-header', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.blocktext3col-item', { delay: 200, duration: 600, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', opacity: 0, distance: '100px', origin: 'top', interval: 150});

        //ScrollReveal Bloc Pêle mêle accompagnement
        ScrollReveal().reveal('.blockaccompagnement-content', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.blockaccompagnement-item', { delay: 200, duration: 600, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', opacity: 0, distance: '100px', origin: 'top', interval: 150});

        //ScrollReveal Bloc Média
        ScrollReveal().reveal('.blockmedia', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        // ScrollReveal().reveal('.blockmedia-picto .picto', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });

        //ScrollReveal Bloc Découverte
        ScrollReveal().reveal('.blockdiscover-img', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });
        ScrollReveal().reveal('.blockdiscover-text', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });

        //ScrollReveal Bloc Texte avec fond blanc
        ScrollReveal().reveal('.blocktext-whitebg', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.blocktext-wrapper', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});

        //ScrollReveal Header de Niveau 1
        ScrollReveal().reveal('.headerNiveau1-blueWrapper', { delay: 200, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.headerNiveau1-bgimage', { delay: 200, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });
        ScrollReveal().reveal('.headerNiveau1-intro', { delay: 200, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top' });
        ScrollReveal().reveal('.headerNiveau1-optionnel', { delay: 500, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'bottom' });

        //ScrollReveal Header de Niveau 2
        ScrollReveal().reveal('.headerNiveau2-bgimage', { delay: 200, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.headerNiveau2 .breadcrumb', { delay: 600, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.headerNiveau2-content', { delay: 600, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.headerNiveau2-optionnel', { delay: 500, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right' });

        //ScrollReveal blocknewslider
        ScrollReveal().reveal('.blocknewslider-whitebg', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left' });
        ScrollReveal().reveal('.blocknewslider-grid .newscard', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right', interval: 150 });

        //headerhome reveal
        ScrollReveal().reveal('.mainmenubar', { delay: 500, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.headerhome-logo', { delay: 100, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.headerhome-thin', { delay: 200, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top' });
        ScrollReveal().reveal('.headerhome-left', { delay: 400, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left'});
        ScrollReveal().reveal('.headerhome-middle', { delay: 400, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.headerhome-right', { delay: 400, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right'});
        ScrollReveal().reveal('.headerhome-thin2', { delay: 600, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'bottom'});

        ScrollReveal().reveal('.headerhome .scrollanim', { delay: 800, duration: 1000, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'bottom'});
        ScrollReveal().reveal('.headerhome-textwrapper', { delay: 400, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left'});
        ScrollReveal().reveal('.headerhome-media', { delay: 600, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right'});

        //blocktimeline
        ScrollReveal().reveal('.blocktimeline-timeline', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});

        //blocktrombinoscope
        ScrollReveal().reveal('.blocktrombinoscope-item', { delay: 200, duration: 600, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', opacity: 0, distance: '100px', origin: 'top', interval: 150});

        //blocktabs
        ScrollReveal().reveal('.blocktabs-tabs li', { delay: 200, duration: 600, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', opacity: 0, distance: '100px', origin: 'left', interval: 150});
        ScrollReveal().reveal('.blocktabs-container .text', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left'});
        ScrollReveal().reveal('.blocktabs-container .tab-image', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});

        ScrollReveal().reveal('.blockaccompagnementslider-wrapper', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top'});
        ScrollReveal().reveal('.blockimagesmalltext-media', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'right'});
        ScrollReveal().reveal('.blockimagesmalltext-content', { delay: 200, duration: 600, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'left'});
        ScrollReveal().reveal('.blocksnumbers-slides .slide', { delay: 200, duration: 600, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', opacity: 0, distance: '100px', origin: 'top', interval: 150});
    }

    // Fonction qui gère la carte des evenements
    function initMapEvent() {
        if($('.singlevent').length !== 0) {
            var latitude = $('.singlevent').find('#map').attr('data-latitude');
            var longitude = $('.singlevent').find('#map').attr('data-longitude');
            if(latitude && longitude) {
                var centerCoords = { lat: latitude, lng: longitude };
                var zoom = 10;
                var zoomLimits = {
                    min: 2,
                    max: 25
                };
                var tileLayer2D = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
                window.layer2D = L.tileLayer(tileLayer2D, {
                    minZoom: zoomLimits.min,
                    maxZoom: zoomLimits.max,
                    //detectRetina: true,
                    reuseTiles: true
                });
                var map = L.map('map', {
                    center: centerCoords,
                    zoom: zoom,
                    minZoom: zoomLimits.min,
                    maxZoom: zoomLimits.max,
                    touchZoom: true,
                    keyboard: false,
                    attributionControl: false,
                    scrollWheelZoom: false,
                    trackResize: true,
                    fadeAnimation: true,
                    zoomAnimation: true,
                    layerControl: false,
                    layers: [layer2D]
                });
                var myIcon = L.divIcon({
                    className: 'pinpoint',
                    iconSize: [55, 55],
                    iconAnchor: [20, 55],
                    html: '<svg class="icon"><use xlink:href="' + siteUrl + '/app/themes/wp_theme/images/sprites.svg#icone-localisation"></use></svg>'
                });
                var marker = L.marker([latitude, longitude], {icon: myIcon}).addTo(map);
            }
        }
    }

    function initToTop() {
        let btn = $('.btn-topage');
        let footer = $('.footer');

        $(window).scroll(function() {
            if ($(window).scrollTop() > 500) {
                btn.addClass('show');
                btn.removeClass('stop');
            } else {
                btn.removeClass('stop');
                btn.removeClass('show');
            }
        });

        btn.on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({scrollTop:0}, '300');
        });

    }

    function smoothanchors() {
        $('a[href^="#"]').click(function(event) {

            if (this.hash !== "") {

                var hash = this.hash;

                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 500, function() {

                    window.location.hash = hash;
                });
                return false;
            }
        });
    }

    // Fonction qui permet de charger plus de membres de l'équipe
    function load_posts() {
        var postType = $('#more_posts').data('type');
        var taxQuery = $('#more_posts').data('tax');
        var offsetBsc = $('#more_posts').attr('data-nb-posts');
        var totalNbCases = $('#more_posts').attr('data-total-posts');

        var data = {
            'action': 'more_post_ajax',
            'postType' : postType,
            'offset': offsetBsc,
            'taxQuery' : taxQuery
        };

        $.ajax({
            type: "POST",
            dataType: "html",
            url: ajax_posts.ajaxurl,
            data: data,
            success: function (data) {
                var $data = $(data);
                if ($data.length) {
                    $("#ajax-posts").append($data);
                    var nbLoadedCases = $('.blocktrombinoscope-item').length;
                    $('#more_posts').attr('data-nb-posts', nbLoadedCases);
                    if(parseInt(nbLoadedCases) === parseInt(totalNbCases)) {
                        $("#more_posts").hide();
                    }
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR, textStatus, errorThrown)
            }

        });
        return false;
    }

    // Fonction qui permet de scroller jusqu'au contenu après la map
    function scrollToNextContent() {
        var offset = $('.headerhome-content').offset().top - 90;
        $('html, body').animate({scrollTop: offset}, 1000);
    }
